import { __awaiter, __generator } from "tslib";
import { FileType } from '@office-start/document-types';
import { createGuid } from '@office-start/guid-generator';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { logError } from '@office-start/telemetry-service';
import { httpPost } from '@office-start/xhr-service';
import { getTemplateContentData } from '../operations/getTemplateContentData';
import { convertConsumerPuidToGuid } from '../utilities/convertConsumerPuidToGuid';
import { getCreateFormFromTemplateLink } from '../utilities/getCreateFormFromTemplateLink';
var BASE_URL = '/formapi/api';
var createFormTemplateUrl = function (tenantId, ownerType, ownerId) { return "".concat(BASE_URL, "/").concat(tenantId, "/").concat(ownerType, "/").concat(ownerId, "/light/forms"); };
export function createFormFromTemplate(formsOptions, template, formType, ownerId) {
    return __awaiter(this, void 0, void 0, function () {
        var componentContext, formsConfig, identity, guid, tenantId, targetOwnerId, templateContent, url, requestConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!template.TemplateBinaryUrl) {
                        return [2 /*return*/, Promise.reject('Invalid TemplateBinaryUrl')];
                    }
                    componentContext = formsOptions.componentContext, formsConfig = formsOptions.formsConfig, identity = formsOptions.identity;
                    guid = convertConsumerPuidToGuid(identity.puid);
                    tenantId = formsConfig.formsMsaTenantId;
                    targetOwnerId = ownerId || guid;
                    return [4 /*yield*/, getTemplateContentData(FileType.Forms, template.AssetId, template.TemplateBinaryUrl)];
                case 1:
                    templateContent = (_a.sent()).result;
                    if (!templateContent) {
                        return [2 /*return*/, undefined];
                    }
                    url = formsConfig.formsApiPath +
                        createFormTemplateUrl(tenantId, formType, targetOwnerId);
                    requestConfig = {
                        method: "POST" /* HttpRequestMethod.Post */,
                        headers: {
                            'content-type': 'application/json',
                            'x-ms-form-request-source': 'ms-startpage',
                            'x-usersessionid': componentContext.sessionId,
                            'x-correlationid': createGuid(),
                            'x-anchormailbox': "".concat(guid, "@").concat(tenantId),
                        },
                    };
                    return [2 /*return*/, httpPost(KnownInstrumentationEvents.FormCreateFormFromTemplate, "Form_Create_Form_From_Template" /* KnownRequestInstrumentationEvents.FormCreateFormFromTemplate */, url, templateContent.Value, requestConfig, componentContext.jwtAuthEnabled, componentContext.getAccessToken, componentContext.officeHomeApiRoot, componentContext.correlationId, 'Forms', {
                            populateRequestEvent: function (_response, params) {
                                params["ElementId" /* InstrumentationParam.ElementId */] = template.AssetId;
                            },
                        })
                            .then(function (response) {
                            if ((response === null || response === void 0 ? void 0 : response.ok) && (response === null || response === void 0 ? void 0 : response.data)) {
                                return getCreateFormFromTemplateLink(formsOptions, response.data.id);
                            }
                            else {
                                throw new Error((response === null || response === void 0 ? void 0 : response.statusText) || 'Form create failed');
                            }
                        })
                            .catch(function (error) {
                            logError({
                                eventName: 'Form_Create_Error',
                                message: error,
                            });
                            return undefined;
                        })];
            }
        });
    });
}
//# sourceMappingURL=createFormFromTemplate.js.map